var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { Button, Form as UIForm } from 'semantic-ui-react';
import { RequestPasswordSetupError, RequestPasswordSetupRequest, } from '~/Api/Authentication';
import { useApi } from '~/ApiHooks';
var ValidationError;
(function (ValidationError) {
    ValidationError[ValidationError["deactivatedAccount"] = 0] = "deactivatedAccount";
    ValidationError[ValidationError["expiredAccount"] = 1] = "expiredAccount";
    ValidationError[ValidationError["unknownEmail"] = 2] = "unknownEmail";
})(ValidationError || (ValidationError = {}));
var errorText = function (error, contact) {
    switch (error) {
        case ValidationError.unknownEmail:
            return 'Zkontrolujte zda jste zadali správný email';
        case ValidationError.deactivatedAccount:
            return "V\u00E1\u0161 \u00FA\u010Det nen\u00ED aktivn\u00ED, kontaktujte pros\u00EDm ".concat(contact);
        case ValidationError.expiredAccount:
            return "V\u00E1\u0161 \u00FA\u010Det ji\u017E nen\u00ED aktivn\u00ED, kontaktujte pros\u00EDm ".concat(contact);
        default:
            return null;
    }
};
var Form = function (_a) {
    var contact = _a.contact, disabled = _a.disabled, error = _a.error, onChange = _a.onChange, onSubmit = _a.onSubmit;
    var submit = function (event) {
        event.preventDefault();
        if (event.currentTarget.reportValidity()) {
            onSubmit();
        }
    };
    return (<UIForm noValidate size='large' onSubmit={submit}>
			<UIForm.Input autoFocus fluid required disabled={disabled} error={error !== null ? errorText(error, contact) : null} icon='user' iconPosition='left' label='Email' placeholder='me@example.com' type='email' onChange={function (event) {
            onChange(event.target.value);
        }}/>

			<Button disabled={disabled} size='large'>
				Resetovat heslo
			</Button>
		</UIForm>);
};
export var Reset = function (_a) {
    var contact = _a.contact, onComplete = _a.onComplete;
    var _b = React.useState(''), email = _b[0], setEmail = _b[1];
    var _c = React.useState(null), validationError = _c[0], setValidationError = _c[1];
    var _d = useApi(), reset = _d[0], result = _d[1];
    var updateEmail = function (email) {
        setEmail(email);
        setValidationError(null);
    };
    var submit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        var _a, _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0: return [4 /*yield*/, reset(new RequestPasswordSetupRequest(email.trim()))];
                case 1:
                    response = _g.sent();
                    if (response.value !== null) {
                        onComplete();
                    }
                    else if ((_b = (_a = response.error) === null || _a === void 0 ? void 0 : _a.has(RequestPasswordSetupError.unknownEmail)) !== null && _b !== void 0 ? _b : false) {
                        setValidationError(ValidationError.unknownEmail);
                    }
                    else if ((_d = (_c = response.error) === null || _c === void 0 ? void 0 : _c.has(RequestPasswordSetupError.deactivatedAccount)) !== null && _d !== void 0 ? _d : false) {
                        setValidationError(ValidationError.deactivatedAccount);
                    }
                    else if ((_f = (_e = response.error) === null || _e === void 0 ? void 0 : _e.has(RequestPasswordSetupError.expiredAccount)) !== null && _f !== void 0 ? _f : false) {
                        setValidationError(ValidationError.expiredAccount);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return (<Form contact={contact} disabled={result.isLoading} error={validationError} onChange={updateEmail} onSubmit={submit}/>);
};
Reset.displayName = 'Password.Reset';
